import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from '@storable/canaveral-components';
import { Link } from 'react-router';
import gql from 'graphql-tag';

const propTypes = {
  localeCode: PropTypes.string.isRequired,
  type: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    pageLayout: PropTypes.shape({
      latestVerion: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

const defaultProps = {};

const PageLayoutTypesMenuItem = ({
  localeCode,
  type: {
    id,
    name,
    pageLayout: {
      latestVersion: {
        id: latestVersionId,
      },
    },
  },
}) => (
  <Menu.Item
    componentClass={Link}
    to={`/admin/locales/${localeCode}/types/${id}/page-layout/versions/${latestVersionId}/edit`}
  >
    {name}
  </Menu.Item>
);

PageLayoutTypesMenuItem.propTypes = propTypes;
PageLayoutTypesMenuItem.defaultProps = defaultProps;

PageLayoutTypesMenuItem.fragments = {
  pageType: gql`
    fragment PageLayoutTypesMenuItemPageType on PageType {
      id
      name
      pageLayout(localeCode: $localeCode)  {
        id
        latestVersion {
          id
        }
      }
    }
  `,
  siteType: gql`
    fragment PageLayoutTypesMenuItemSiteType on SiteType {
      id
      name
      pageLayout(localeCode: $localeCode)  {
        id
        latestVersion {
          id
        }
      }
    }
  `,
};

export default PageLayoutTypesMenuItem;
